import type { SportBadge } from "./unified-types";
import { isSupProfileKey, sportPresentation } from "./sport-profiles";

export const SPORT_LABELS: Record<string, string> = {
  surf: "Surf", wind: "Wind", foil: "Prone Foil", "downwind-foil": "Downwind Foil",
  "wing-foil": "Wing Foil", diving: "Diving", swimming: "Swimming", swim: "Swimming",
  sup: "SUP", bodyboarding: "Bodyboarding", piste: "Piste",
  "off-piste": "Off-Piste", touring: "Touring", mtb: "MTB",
  "sailing-club": "Sailing", "sailing-hp": "Performance sailing",
};

export const SPORT_ICONS: Record<string, string> = {
  surf: "🏄", wind: "🪁", foil: "🌊", "downwind-foil": "🌊", "wing-foil": "🪂",
  diving: "🤿", swimming: "🏊", swim: "🏊", sup: "🛶", bodyboarding: "🏄",
  piste: "⛷️", "off-piste": "🏔️", touring: "🎿", mtb: "🚵",
  "sailing-club": "⛵", "sailing-hp": "⛵",
};

export function sportLabel(sport: string): string {
  if (isSupProfileKey(sport)) return sportPresentation(sport).label;
  return SPORT_LABELS[sport] ?? sport;
}

export function sportIcon(sport: string): string {
  if (isSupProfileKey(sport)) return sportPresentation(sport).icon;
  return SPORT_ICONS[sport] ?? "🏅";
}

export function sportIsBeta(sport: string): boolean {
  return isSupProfileKey(sport) && sportPresentation(sport).isBeta;
}

/** Selector order: in-season sports first (best score first), then off-season
 *  (best score first). Stable; never mutates the input. */
export function rankBadges(badges: SportBadge[]): SportBadge[] {
  return [...badges].sort((a, b) => {
    const aOff = a.offSeason ? 1 : 0;
    const bOff = b.offSeason ? 1 : 0;
    if (aOff !== bOff) return aOff - bOff;
    return (b.score ?? Number.NEGATIVE_INFINITY) -
      (a.score ?? Number.NEGATIVE_INFINITY);
  });
}
